import { decryptId } from "../../../Components/CryptoComponent";
import AddLookup from "../../../Components/InputComponents/AddLookup";
import { useParams, useSearchParams } from "react-router-dom";

function EditYearsOfExperience() {
  const { id } = useParams();
  const decryptedId = decryptId(decodeURIComponent(id));

  const [searchParams] = useSearchParams();
  const redirectURL = `/YearsOfExperienceLookup?${searchParams.toString()}`;

  return (
    <AddLookup
      title="Edit Years of Experience"
      alert="Years of Experience Edited Successfully"
      editDataAPIEndPoint={`/YearofExp/Edit/${decryptedId}`}
      viewDataDetailsAPIEndPoint={`/YearofExp/listbyId/${decryptedId}`}
      redirectURL={redirectURL}
      sections={[
        {
          fields: [
            {
              type: "text",
              label: "Years of Experience",
              name: "YEL_Name",
              required: true, // Validation rule added here
               maxLength:70
            },
            {
              type: "select",
              label: "Status",
              name: "YEL_Status",
              required: true, // Validation rule added here
                            options: [
                { label: "Active", value:'1'},
                { label: "Inactive", value: '0'},
              ],
            },
          ],
        },
      ]}
      validationRules={{
        YEL_Name: {
          required: true,
          
        },
        YEL_Status: {
          required: true,
        },
      }}
    />
  );
}

export default EditYearsOfExperience;
